'use client';
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Flex,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorModeValue,
   useDisclosure,
   Checkbox,
   Drawer,
   DrawerOverlay,
   DrawerContent,
   DrawerCloseButton,
   DrawerHeader,
   DrawerBody,
   useOutsideClick,
   Spinner,
} from '@chakra-ui/react';
import Select from 'react-select';
import 'jspdf-autotable';
import Card from 'components/card/Card';
import { GridItem, Input } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import {
   Button,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalFooter,
   ModalBody,
   ModalCloseButton,
   Image,
   Thead,
   Th,
   Grid,
   IconButton,
} from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import DynamicFilterall from '../components/DynamicFilterall';
import { useDispatch, useSelector } from 'react-redux';
import StatementFilter from '../components/StatementFilter';
import { IoFilterOutline } from 'react-icons/io5';
import cancel from '../../../../assets/img/nfts/cancel.svg';
import { getBalanceSheet, getbalanceSheetSummary, getbalanceSheetVertical } from '../../../../redux/actions/reports';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import { SearchIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { REPORT_TYPE } from 'constants';
import { renderDynamicDropdown } from '../../../../components/ui/DynamicDropdown';
import { jsPDF } from 'jspdf';
import * as XLSX from 'xlsx';
import { getAccount } from '../../../../redux/actions/account';
import { useUser } from 'contexts';
import { motion } from 'framer-motion';
import { LuRefreshCcw } from 'react-icons/lu';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { useGlobal } from 'contexts';
import Loader from 'views/admin/default/Loader';

const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);
const MIN_LOADING_TIME = 300;

const BalanceSheet = () => {
   // Constants
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
   const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
   const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
   const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
   const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
   const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
   const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
   const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
   const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');
   const companyBg = useColorModeValue('#F1F0E8', '#16213E');

   // Redux state
   const company = useSelector((state) => state.company.list || []);
   const accounts = useSelector((state) => state.account.list || []);
   const balanceSheet = useSelector((state) => state.reports?.balanceSheet || []);
   const balanceSheetSummary = useSelector((state) => state.reports?.balanceSheetSummary || []);
   const balanceSheetVertical = useSelector((state) => state.reports?.balanceSheetVertical || []);

   // Refs
   const abortControllerRef = useRef(null);
   const searchTimeoutRef = useRef(null);
   const fromDateInputRef = useRef(null);
   const wrapperRef = useRef();
   const initialLoadRef = useRef(true);

   // State
   const [companyFilter, setCompanyFilter] = useState([]);
   const [isLoading, setIsLoading] = useState(false);
   const [reportType, setReportType] = useState('Balance sheet T Format');
   const [expandedItems, setExpandedItems] = useState({});
   const [sorting, setSorting] = useState([]);
   const [columnVisibility, setColumnVisibility] = useState({});
   const [isColumnSelectorOpen, setIsColumnSelectorOpen] = useState(false);
   const [searchQuery, setSearchQuery] = useState('');
   const [expanded, setExpanded] = useState(false);
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const [stockWiseSelected, setStockWiseSelected] = useState(null);
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);

      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0], // last 7th day
         toDate: today.toISOString().split('T')[0], // today
      };
   });

   // Context and utilities
   const dbName = localStorage.getItem('dbName');
   const { user } = useUser();
   const dispatch = useDispatch();
   const { isOpen, onOpen, onClose } = useDisclosure();
   // Constants
   const reportTypeOptions = [
      { value: 'Balance sheet T Format', label: 'Balance sheet T Format' },
      { value: 'Balance sheet Vertical', label: 'Balance sheet Vertical' },
      { value: 'Balance sheet Summary', label: 'Balance sheet Summary' },
   ];

   // Memoized values
   const { companyList, userGlobalSettingsData } = useGlobal();
   const globalSettingAcc = userGlobalSettingsData?.[0]?.askCompany?.account;
   const shouldShowCompanyDropdownAcc = globalSettingAcc || false;

   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );

   const companyIds = useMemo(
      () =>
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
            ? [parseInt(localStorage.getItem('companyId'))]
            : [],
      [companyFilter],
   );

   // Initialize default values
   useEffect(() => {
      const storedCompanyId = localStorage.getItem('companyId');
      if (storedCompanyId && companyList.length > 0) {
         const companyId = parseInt(storedCompanyId);
         const matchingCompany = companyList.find((comp) => comp.id === companyId);
         if (matchingCompany) {
            setCompanyFilter([matchingCompany.id]);
         }
      }
   }, [companyList]);

   useEffect(() => {
      const initialVisibility = {
         accountName: true,
         debit: reportType === 'Balance sheet Vertical',
         credit: reportType === 'Balance sheet Vertical',
         liability: reportType === 'Balance sheet T Format',
         liabilityAmount: reportType === 'Balance sheet T Format',
         asset: reportType === 'Balance sheet T Format',
         assetAmount: reportType === 'Balance sheet T Format',
      };
      setColumnVisibility(initialVisibility);
   }, [reportType]);

   const fetchData = useCallback(async () => {
      // Validate companyIds - must be an array with at least one valid number
      if (
         !Array.isArray(companyIds) ||
         companyIds.length === 0 ||
         companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0)
      ) {
         console.log('Invalid company IDs, skipping API call');
         return;
      }

      // Cancel any pending request
      if (abortControllerRef.current) {
         abortControllerRef.current.abort();
      }

      abortControllerRef.current = new AbortController();
      const startTime = Date.now();
      setIsLoading(true);

      try {
         // Filter out any invalid IDs just to be safe
         const validCompanyIds = companyIds.filter((id) => !isNaN(Number(id)) && Number(id) > 0);

         if (dateRange.fromDate && dateRange.toDate && validCompanyIds.length > 0) {
            if (reportType === 'Balance sheet Summary') {
               await dispatch(
                  getbalanceSheetSummary({
                     companyIds: validCompanyIds.join(','),
                     fromDate: dateRange.fromDate,
                     toDate: dateRange.toDate,
                     search: searchQuery,
                  }),
                  { signal: abortControllerRef.current.signal },
               );
            } else if (reportType === 'Balance sheet Vertical') {
               await dispatch(
                  getbalanceSheetVertical({
                     companyIds: validCompanyIds.join(','),
                     fromDate: dateRange.fromDate,
                     toDate: dateRange.toDate,
                     search: searchQuery,
                  }),
                  { signal: abortControllerRef.current.signal },
               );
            } else {
               await dispatch(
                  getBalanceSheet({
                     companyIds: validCompanyIds.join(','),
                     fromDate: dateRange.fromDate,
                     toDate: dateRange.toDate,
                     search: searchQuery,
                  }),
                  { signal: abortControllerRef.current.signal },
               );
            }
         }
      } catch (error) {
         if (error.name !== 'AbortError') {
            console.error('Error fetching balance sheet:', error);
         }
      } finally {
         // Calculate remaining time to meet minimum loading duration
         const elapsedTime = Date.now() - startTime;
         const remainingTime = Math.max(0, MIN_LOADING_TIME - elapsedTime);

         // Only wait if we need to meet the minimum loading time
         if (remainingTime > 0) {
            await new Promise((resolve) => setTimeout(resolve, remainingTime));
         }

         setIsLoading(false);
         abortControllerRef.current = null;
      }
   }, [dispatch, companyIds, reportType, searchQuery, dateRange]);

   // Initialize default values - ONLY SET INITIAL STATE, NO API CALLS
   useEffect(() => {
      const storedCompanyId = localStorage.getItem('companyId');
      if (storedCompanyId && companyList.length > 0) {
         const companyId = parseInt(storedCompanyId);
         const matchingCompany = companyList.find((comp) => comp.id === companyId);
         if (matchingCompany) {
            setCompanyFilter([matchingCompany.id]);
         }
      }
   }, [companyList]);

   // Column visibility effect - NO API CALLS
   useEffect(() => {
      const initialVisibility = {
         accountName: true,
         debit: reportType === 'Balance sheet Vertical',
         credit: reportType === 'Balance sheet Vertical',
         liability: reportType === 'Balance sheet T Format',
         liabilityAmount: reportType === 'Balance sheet T Format',
         asset: reportType === 'Balance sheet T Format',
         assetAmount: reportType === 'Balance sheet T Format',
      };
      setColumnVisibility(initialVisibility);
   }, [reportType]);

   // MAIN DATA FETCHING EFFECT - SINGLE SOURCE OF TRUTH
   useEffect(() => {
      // Skip initial load
      if (initialLoadRef.current) {
         initialLoadRef.current = false;
         return;
      }

      fetchData();
   }, [fetchData]);

   // Debounced search effect
   useEffect(() => {
      if (searchTimeoutRef.current) {
         clearTimeout(searchTimeoutRef.current);
      }

      // Only search if we have valid parameters and it's not initial load
      if (!initialLoadRef.current && companyIds.length > 0 && dateRange.fromDate && dateRange.toDate) {
         searchTimeoutRef.current = setTimeout(() => {
            fetchData();
         }, 300);
      }

      return () => {
         if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
         }
      };
   }, [searchQuery, fetchData, companyIds, dateRange]);

   // Initial data load effect
   useEffect(() => {
      // Validate all parameters before fetching data
      const hasValidCompanyIds =
         Array.isArray(companyIds) &&
         companyIds.length > 0 &&
         !companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0);
      const hasValidDateRange = dateRange.fromDate && dateRange.toDate;

      if (hasValidCompanyIds && hasValidDateRange && initialLoadRef.current) {
         initialLoadRef.current = false;
         fetchData();
      }
   }, [companyIds, dateRange, fetchData]);

   // Event handlers
   const handleDateRangeChange = useCallback((dates) => {
      if (!dates || dates.length !== 2) return;
      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));
      setDateRange({ fromDate: from, toDate: to });
   }, []);

   const handleRefresh = useCallback(() => {
      // Cancel any pending search timeout
      if (searchTimeoutRef.current) {
         clearTimeout(searchTimeoutRef.current);
      }

      // Cancel any ongoing API request
      if (abortControllerRef.current) {
         abortControllerRef.current.abort();
      }

      // Trigger the data fetch
      fetchData();
   }, [fetchData]);

   const handleCompanyChange = useCallback((selectedOptions) => {
      setCompanyFilter(selectedOptions ? selectedOptions : []);
   }, []);

   const handleSearchChange = useCallback((e) => {
      const value = e.target.value;
      setSearchQuery(value);
   }, []);

   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   // Table configuration
   const columnHelper = createColumnHelper();

   const getColumns = useCallback(
      (reportType) => {
         const commonColumns = [
            columnHelper.accessor('accountName', {
               id: 'accountName',
               headerText: 'Account',
               header: () => (
                  <Text
                     justifyContent="space-between"
                     align="center"
                     fontSize={{ sm: '10px', lg: '12px' }}
                     color={textColor}>
                     Account
                  </Text>
               ),
               cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
            }),
         ];

         if (reportType === 'Balance sheet T Format') {
            return [
               columnHelper.accessor('liability', {
                  id: 'liability',
                  headerText: 'Liability',
                  header: () => (
                     <Text
                        justifyContent="space-between"
                        align="center"
                        fontSize={{ sm: '10px', lg: '12px' }}
                        color={textColor}>
                        Liability
                     </Text>
                  ),
                  cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
               }),
               columnHelper.accessor('liabilityAmount', {
                  id: 'liabilityAmount',
                  headerText: 'Amount',
                  header: () => (
                     <Text
                        justifyContent="space-between"
                        align="center"
                        fontSize={{ sm: '10px', lg: '12px' }}
                        color={textColor}>
                        Amount
                     </Text>
                  ),
                  cell: (info) => {
                     const value = info.getValue();
                     if (!value) return <Flex align="center">-</Flex>;
                     return (
                        <Flex align="center" justifyContent="flex-end">
                           {value}
                        </Flex>
                     );
                  },
               }),
               columnHelper.accessor('asset', {
                  id: 'asset',
                  headerText: 'Asset',
                  header: () => (
                     <Text
                        justifyContent="space-between"
                        align="center"
                        fontSize={{ sm: '10px', lg: '12px' }}
                        color={textColor}>
                        Asset
                     </Text>
                  ),
                  cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
               }),
               columnHelper.accessor('assetAmount', {
                  id: 'assetAmount',
                  headerText: 'Amount',
                  header: () => (
                     <Text
                        justifyContent="space-between"
                        align="center"
                        fontSize={{ sm: '10px', lg: '12px' }}
                        color={textColor}>
                        Amount
                     </Text>
                  ),
                  cell: (info) => {
                     const value = info.getValue();
                     if (!value) return <Flex align="center">-</Flex>;
                     return (
                        <Flex align="center" justifyContent="flex-end">
                           {value}
                        </Flex>
                     );
                  },
               }),
            ];
         }

         if (reportType === 'Balance sheet Vertical') {
            return [
               ...commonColumns,
               columnHelper.accessor('debit', {
                  id: 'debit',
                  headerText: 'Debit',
                  header: () => (
                     <Text
                        justifyContent="space-between"
                        align="center"
                        fontSize={{ sm: '10px', lg: '12px' }}
                        color={textColor}>
                        Debit
                     </Text>
                  ),
                  cell: (info) => {
                     const value = info.getValue();
                     if (value === null || value === undefined) return <Flex align="center">-</Flex>;
                     const numValue = Number(value);
                     if (isNaN(numValue)) return <Flex align="center">{value}</Flex>;
                     return (
                        <Flex align="center" justifyContent="flex-end">
                           ₹{numValue.toLocaleString()}
                        </Flex>
                     );
                  },
               }),
               columnHelper.accessor('credit', {
                  id: 'credit',
                  headerText: 'Credit',
                  header: () => (
                     <Text
                        justifyContent="space-between"
                        align="center"
                        fontSize={{ sm: '10px', lg: '12px' }}
                        color={textColor}>
                        Credit
                     </Text>
                  ),
                  cell: (info) => {
                     const value = info.getValue();
                     if (value === null || value === undefined) return <Flex align="center">-</Flex>;
                     const numValue = Number(value);
                     if (isNaN(numValue)) return <Flex align="center">{value}</Flex>;
                     return (
                        <Flex align="center" justifyContent="flex-end">
                           ₹{numValue.toLocaleString()}
                        </Flex>
                     );
                  },
               }),
            ];
         }

         return commonColumns;
      },
      [columnHelper, textColor],
   );

   const columns = useMemo(() => getColumns(reportType), [reportType, getColumns]);

   const table = useReactTable({
      data:
         reportType === 'Balance sheet Vertical'
            ? balanceSheetVertical
            : reportType === 'Balance sheet Summary'
            ? balanceSheetSummary
            : balanceSheet,
      columns,
      state: {
         sorting,
         columnVisibility,
      },
      onSortingChange: setSorting,
      onColumnVisibilityChange: setColumnVisibility,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   // Formatting functions
   const formatCurrency = useCallback((value) => {
      if (value === null || value === undefined) return '-';
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return `₹${Math.abs(numValue).toLocaleString('en-IN')}`;
   }, []);

   // Render functions
   const renderTFormatBalanceSheet = useCallback(() => {
      if (!balanceSheet || balanceSheet.length === 0) {
         return (
            <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
               <Td
                  p="2px"
                  py="3px"
                  fontSize="10px"
                  whiteSpace="nowrap"
                  textOverflow="ellipsis"
                  maxW="150px"
                  overflow="hidden"
                  colSpan={4}
                  justifyContent="center"
                  alignItems="center"
                  width="100%">
                  <Grid justifyContent="center" alignItems="center" gap={9}>
                     <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                     <GridItem justifySelf="center">
                        <label>No balance sheet data found</label>
                     </GridItem>
                  </Grid>
               </Td>
            </Tr>
         );
      }

      return balanceSheet.map((companyData) => {
         const companyName = companyData.companyName || '';
         const data = companyData.data || [];

         if (data.length === 0) return null;

         const flattenedData = data.map((group) => ({
            ...group,
            data: group.data.map((item) => ({
               ...item,
               groupName: group.groupName,
               debit: item.adjustedBalance < 0 ? Math.abs(item.adjustedBalance) : 0,
               credit: item.adjustedBalance > 0 ? item.adjustedBalance : 0,
            })),
         }));

         const groupedData = flattenedData.reduce((acc, group) => {
            group.data.forEach((item) => {
               const mainCategory =
                  item.debit && !item.credit ? 'Assets' : item.credit && !item.debit ? 'Liabilities' : 'Other';
               const subCategory = group.groupName || 'Others';

               if (!acc[mainCategory]) acc[mainCategory] = {};
               if (!acc[mainCategory][subCategory]) acc[mainCategory][subCategory] = [];
               acc[mainCategory][subCategory].push(item);
            });
            return acc;
         }, {});

         const createRows = () => {
            const liabilitiesData = groupedData['Liabilities'] || {};
            const assetsData = groupedData['Assets'] || {};
            const rows = [];

            // Add company name row
            rows.push({
               type: 'company',
               liability: companyName,
               colSpan: 5,
            });

            // Add headers
            rows.push({
               type: 'header',
               liability: 'LIABILITY',
               asset: 'ASSETS',
            });

            const liabilityCategories = Object.keys(liabilitiesData);
            const assetCategories = Object.keys(assetsData);
            const maxCategories = Math.max(liabilityCategories.length, assetCategories.length);

            for (let i = 0; i < maxCategories; i++) {
               const liabilityCategory = liabilityCategories[i];
               const assetCategory = assetCategories[i];

               if (liabilityCategory || assetCategory) {
                  rows.push({
                     type: 'category',
                     liability: liabilityCategory ? liabilityCategory.toUpperCase() : '',
                     asset: assetCategory ? assetCategory.toUpperCase() : '',
                  });
               }

               const liabilityItems = liabilityCategory ? liabilitiesData[liabilityCategory] : [];
               const assetItems = assetCategory ? assetsData[assetCategory] : [];
               const maxItems = Math.max(liabilityItems.length, assetItems.length);

               for (let j = 0; j < maxItems; j++) {
                  const liabilityItem = liabilityItems[j];
                  const assetItem = assetItems[j];

                  rows.push({
                     type: 'item',
                     liability: liabilityItem ? liabilityItem.accountName : '',
                     liabilityAmount: liabilityItem ? formatCurrency(liabilityItem.credit) : '',
                     asset: assetItem ? assetItem.accountName : '',
                     assetAmount: assetItem ? formatCurrency(assetItem.debit) : '',
                  });
               }
            }

            const totalLiabilities = Object.values(liabilitiesData).reduce(
               (sum, items) => sum + items.reduce((subSum, item) => subSum + (Number(item.credit) || 0), 0),
               0,
            );

            const totalAssets = Object.values(assetsData).reduce(
               (sum, items) => sum + items.reduce((subSum, item) => subSum + (Number(item.debit) || 0), 0),
               0,
            );

            rows.push({
               type: 'grandtotal',
               liability: 'Grand Total:',
               liabilityAmount: formatCurrency(totalLiabilities),
               asset: 'Grand Total:',
               assetAmount: formatCurrency(totalAssets),
            });

            return rows;
         };

         const rows = createRows();

         const getRowStyle = (type) => {
            const styles = {
               fontWeight: 'bold',
               fontSize: type === 'header' || type === 'grandtotal' ? '16px' : '14px',
            };

            if (type === 'company') return { ...styles, bg: '#F7ECDE', fontSize: '18px' };
            if (type === 'header') return { ...styles, bg: '', textTransform: 'uppercase' };
            if (type === 'category') return { ...styles, bg: companyBg, textTransform: 'uppercase' };
            if (type === 'grandtotal')
               return { ...styles, bg: 'green.50', borderTop: '2px solid', borderColor: 'green.500' };
            return {};
         };

         return rows.map((row, index) => {
            if (row.type === 'company') {
               return (
                  <Tr key={`${companyName}-row-${index}`}>
                     <Td
                        colSpan={row.colSpan}
                        p="8px"
                        fontSize={'18px'}
                        color={textColor}
                        borderColor={borderColor}
                        {...getRowStyle(row.type)}>
                        {row.liability}
                     </Td>
                  </Tr>
               );
            }

            return (
               <Tr
                  key={`${companyName}-row-${index}`}
                  bg={row.type === 'item' && index % 2 === 0 ? 'white' : 'transparent'}
                  _dark={{ bg: row.type === 'item' && index % 2 === 0 ? '#101F4A' : 'transparent' }}>
                  <Td p="2px" fontSize={'14px'} color={textColor} borderColor={borderColor} {...getRowStyle(row.type)}>
                     {row.liability}
                  </Td>
                  <Td
                     p="2px"
                     fontSize={'14px'}
                     color={textColor}
                     borderColor={borderColor}
                     textAlign="right"
                     {...getRowStyle(row.type)}>
                     {row.liabilityAmount || ''}
                  </Td>
                  <Td
                     p="2px"
                     fontSize={'14px'}
                     color={textColor}
                     borderColor={borderColor}
                     {...getRowStyle(row.type)}></Td>
                  <Td p="2px" fontSize={'14px'} color={textColor} borderColor={borderColor} {...getRowStyle(row.type)}>
                     {row.asset}
                  </Td>
                  <Td
                     p="2px"
                     fontSize={'14px'}
                     color={textColor}
                     borderColor={borderColor}
                     textAlign="right"
                     {...getRowStyle(row.type)}>
                     {row.assetAmount || ''}
                  </Td>
               </Tr>
            );
         });
      });
   }, [balanceSheet, borderColor, formatCurrency, textColor, companyBg]);

   const renderSummaryBalanceSheet = useCallback(() => {
      if (!balanceSheetSummary || balanceSheetSummary.length === 0) {
         return (
            <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
               <Td
                  p="2px"
                  py="3px"
                  fontSize="10px"
                  whiteSpace="nowrap"
                  textOverflow="ellipsis"
                  maxW="150px"
                  overflow="hidden"
                  colSpan={5}
                  justifyContent="center"
                  alignItems="center"
                  width="100%">
                  <Grid justifyContent="center" alignItems="center" gap={9}>
                     <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                     <GridItem justifySelf="center">
                        <label>No balance sheet data found</label>
                     </GridItem>
                  </Grid>
               </Td>
            </Tr>
         );
      }

      return balanceSheetSummary.map((companyData) => {
         const companyName = companyData.companyName || '';
         const balanceSheetData = companyData.data || [];

         const categorizeBalanceSheetItems = (data) => {
            const liabilities = [];
            const assets = [];

            data.forEach((item) => {
               if (item.section === 'LIABILITIES') {
                  liabilities.push({
                     category: item.category,
                     amount: item.amount || 0,
                  });
               } else if (item.section === 'ASSETS') {
                  assets.push({
                     category: item.category,
                     amount: item.amount || 0,
                  });
               }
            });

            return { liabilities, assets };
         };

         const { liabilities, assets } = categorizeBalanceSheetItems(balanceSheetData);
         const totalLiabilities = liabilities.reduce((sum, item) => sum + Number(item.amount || 0), 0);
         const totalAssets = assets.reduce((sum, item) => sum + Number(item.amount || 0), 0);
         const maxRows = Math.max(liabilities.length, assets.length);

         return (
            <React.Fragment key={companyName}>
               <Tr mt={3}>
                  <Td
                     colSpan={5}
                     p="8px"
                     fontSize={'18px'}
                     fontWeight="bold"
                     color={textColor}
                     borderColor={borderColor}
                     // textAlign="center"
                     bg="#F7ECDE">
                     {companyName}
                  </Td>
               </Tr>

               {Array.from({ length: maxRows }).map((_, index) => (
                  <Tr
                     key={`${companyName}-summary-row-${index}`}
                     bg={index % 2 === 0 ? 'white' : 'rgba(0, 63, 140, 0.05)'}
                     _dark={{ bg: index % 2 === 0 ? '#101F4A' : 'rgba(2, 14, 56, 0.7)' }}>
                     <Td p="8px" fontSize={'14px'} color={textColor} borderColor={borderColor} width="30%">
                        {liabilities[index] && <Text fontWeight="500">{liabilities[index].category}</Text>}
                     </Td>
                     <Td p="8px" fontSize={'14px'} color={textColor} borderColor={borderColor} width="20%" isNumeric>
                        {liabilities[index] && (
                           <Text fontWeight="500">{formatCurrency(liabilities[index].amount)}</Text>
                        )}
                     </Td>
                     <Td width="5%" borderColor={borderColor}></Td>
                     <Td p="8px" fontSize={'14px'} color={textColor} borderColor={borderColor} width="30%">
                        {assets[index] && <Text fontWeight="500">{assets[index].category}</Text>}
                     </Td>
                     <Td p="8px" fontSize={'14px'} color={textColor} borderColor={borderColor} width="20%" isNumeric>
                        {assets[index] && <Text fontWeight="500">{formatCurrency(assets[index].amount)}</Text>}
                     </Td>
                  </Tr>
               ))}

               <Tr
                  fontWeight="bold"
                  borderTop="2px solid"
                  borderColor={borderColor}
                  bg="rgba(0, 63, 140, 0.1)"
                  _dark={{ bg: 'rgba(2, 14, 56, 0.9)' }}>
                  <Td p="8px" fontSize="16px" color={textColor} fontWeight="bold">
                     <Text>Total Liabilities</Text>
                  </Td>
                  <Td p="8px" fontSize="16px" color={textColor} fontWeight="bold" isNumeric>
                     <Text>{formatCurrency(totalLiabilities)}</Text>
                  </Td>
                  <Td></Td>
                  <Td p="8px" fontSize="16px" color={textColor} fontWeight="bold">
                     <Text>Total Assets</Text>
                  </Td>
                  <Td p="8px" fontSize="16px" color={textColor} fontWeight="bold" isNumeric>
                     <Text>{formatCurrency(totalAssets)}</Text>
                  </Td>
               </Tr>
            </React.Fragment>
         );
      });
   }, [balanceSheetSummary, borderColor, formatCurrency, textColor]);

   const renderReportContent = useCallback(() => {
      if (isLoading) {
         return (
            <Tr>
               <Td colSpan={table.getVisibleFlatColumns().length} textAlign="center" py="100px">
                  <Loader />
               </Td>
            </Tr>
         );
      }

      if (!balanceSheet || balanceSheet.length === 0) {
         return (
            <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
               <Td
                  p="2px"
                  py="3px"
                  fontSize="10px"
                  whiteSpace="nowrap"
                  textOverflow="ellipsis"
                  maxW="150px"
                  overflow="hidden"
                  colSpan={table.getVisibleFlatColumns().length}
                  justifyContent="center"
                  alignItems="center"
                  width="100%">
                  <Grid justifyContent="center" alignItems="center" gap={9}>
                     <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                     <GridItem justifySelf="center">
                        <label>No balance sheet data found</label>
                     </GridItem>
                  </Grid>
               </Td>
            </Tr>
         );
      }

      if (reportType === 'Balance sheet T Format') return renderTFormatBalanceSheet();
      if (reportType === 'Balance sheet Summary') return renderSummaryBalanceSheet();

      return balanceSheetVertical.map((company, companyIndex) => {
         const companyRows = [];

         company.data.forEach((group, groupIndex) => {
            companyRows.push(
               <Tr
                  key={`company-${companyIndex}-group-${groupIndex}-header`}
                  bg="rgba(0, 63, 140, 0.15)"
                  _dark={{ bg: 'rgba(2, 14, 56, 0.8)' }}>
                  <Td
                     p="4px"
                     fontSize={'16px'}
                     fontWeight="bold"
                     color={textColor}
                     borderColor={borderColor}
                     colSpan={3}>
                     {group.groupName}
                  </Td>
               </Tr>,
            );

            group.data.forEach((item, itemIndex) => {
               companyRows.push(
                  <Tr
                     key={`company-${companyIndex}-group-${groupIndex}-item-${itemIndex}`}
                     bg={itemIndex % 2 === 0 ? 'white' : 'rgba(0, 63, 140, 0.05)'}
                     _dark={{ bg: itemIndex % 2 === 0 ? '#101F4A' : 'rgba(2, 14, 56, 0.7)' }}>
                     <Td p="2px" fontSize={'14px'} color={textColor} borderColor={borderColor} pl="20px">
                        {item.accountName || '-'}
                     </Td>
                     <Td p="2px" fontSize={'14px'} color={textColor} borderColor={borderColor} isNumeric>
                        {item.debit ? formatCurrency(item.debit) : '0.00'}
                     </Td>
                     <Td p="2px" fontSize={'14px'} color={textColor} borderColor={borderColor} isNumeric>
                        {item.credit ? formatCurrency(item.credit) : '0.00'}
                     </Td>
                  </Tr>,
               );
            });
         });

         return companyRows;
      });
   }, [
      isLoading,
      balanceSheet,
      balanceSheetVertical,
      reportType,
      renderTFormatBalanceSheet,
      renderSummaryBalanceSheet,
      table,
      textColor,
      borderColor,
      formatCurrency,
   ]);

   // Download functions
   const downloadExcel = useCallback(() => {
      if (reportType === 'Balance sheet T Format') {
         const colors = {
            companyHeader: 'F8FAFC', // Light blue for company headers (matches UI)
            itemHeader: 'F8FAFC', // Light gray for item headers
            oddRow: 'FFFFFF', // White for odd rows
            evenRow: 'F5F5F5', // Light gray for even rows
            totalRow: 'E6FFED', // Light green for totals
            headerText: '000000', // Black for header text
         };
         const headers = ['LIABILITY', '', '', 'ASSETS', ''];
         const finalData = [];
         const styles = [];

         const companyData = balanceSheet[0].data;
         const flattenedData = companyData.map((group) => ({
            ...group,
            data: group.data.map((item) => ({
               ...item,
               groupName: group.groupName,
               debit: item.adjustedBalance < 0 ? Math.abs(item.adjustedBalance) : 0,
               credit: item.adjustedBalance > 0 ? item.adjustedBalance : 0,
            })),
         }));

         const groupedData = flattenedData.reduce((acc, group) => {
            group.data.forEach((item) => {
               const mainCategory =
                  item.debit && !item.credit ? 'Assets' : item.credit && !item.debit ? 'Liabilities' : 'Other';
               const subCategory = group.groupName || 'Others';

               if (!acc[mainCategory]) acc[mainCategory] = {};
               if (!acc[mainCategory][subCategory]) acc[mainCategory][subCategory] = [];
               acc[mainCategory][subCategory].push(item);
            });
            return acc;
         }, {});

         const createRows = () => {
            const liabilitiesData = groupedData['Liabilities'] || {};
            const assetsData = groupedData['Assets'] || {};
            const rows = [];

            // Add headers
            rows.push({
               type: 'header',
               liability: 'LIABILITY',
               asset: 'ASSETS',
            });

            const liabilityCategories = Object.keys(liabilitiesData);
            const assetCategories = Object.keys(assetsData);
            const maxCategories = Math.max(liabilityCategories.length, assetCategories.length);

            for (let i = 0; i < maxCategories; i++) {
               const liabilityCategory = liabilityCategories[i];
               const assetCategory = assetCategories[i];

               if (liabilityCategory || assetCategory) {
                  rows.push({
                     type: 'category',
                     liability: liabilityCategory ? liabilityCategory.toUpperCase() : '',
                     asset: assetCategory ? assetCategory.toUpperCase() : '',
                  });
               }

               const liabilityItems = liabilityCategory ? liabilitiesData[liabilityCategory] : [];
               const assetItems = assetCategory ? assetsData[assetCategory] : [];
               const maxItems = Math.max(liabilityItems.length, assetItems.length);

               for (let j = 0; j < maxItems; j++) {
                  const liabilityItem = liabilityItems[j];
                  const assetItem = assetItems[j];

                  rows.push({
                     type: 'item',
                     liability: liabilityItem ? liabilityItem.accountName : '',
                     liabilityAmount: liabilityItem ? formatCurrency(liabilityItem.credit) : '',
                     asset: assetItem ? assetItem.accountName : '',
                     assetAmount: assetItem ? formatCurrency(assetItem.debit) : '',
                  });
               }
            }

            const totalLiabilities = Object.values(liabilitiesData).reduce(
               (sum, items) => sum + items.reduce((subSum, item) => subSum + (Number(item.credit) || 0), 0),
               0,
            );

            const totalAssets = Object.values(assetsData).reduce(
               (sum, items) => sum + items.reduce((subSum, item) => subSum + (Number(item.debit) || 0), 0),
               0,
            );

            rows.push({
               type: 'grandtotal',
               liability: 'Grand Total:',
               liabilityAmount: formatCurrency(totalLiabilities),
               asset: 'Grand Total:',
               assetAmount: formatCurrency(totalAssets),
            });

            return rows;
         };

         const rows = createRows();

         const getRowStyle = (type) => {
            const baseFontSize = type === 'header' || type === 'grandtotal' ? 16 : 14;
            const baseFont = { bold: true, sz: baseFontSize };

            switch (type) {
               case 'header':
                  return {
                     font: { bold: true, sz: 16, color: { rgb: colors.headerText } },
                     fill: { patternType: 'solid', fgColor: { rgb: 'E5E7EB' } }, // gray.100
                  };

               case 'category':
                  return {
                     font: { sz: baseFontSize },
                     fill: { patternType: 'solid', fgColor: { rgb: 'DBEAFE' } }, // blue.50
                  };

               case 'grandtotal':
                  return {
                     font: { bold: true, sz: 14, color: { rgb: colors.headerText } },
                     fill: { patternType: 'solid', fgColor: { rgb: 'D1FAE5' } }, // green.50
                     border: {
                        top: { style: 'medium', color: { rgb: '10B981' } }, // green.500
                     },
                  };

               default:
                  return {
                     font: { sz: 12 },
                  };
            }
         };

         rows.map((data) => {
            finalData.push([data?.liability, data?.liabilityAmount, '', data?.asset, data?.assetAmount]);
            styles.push(
               Array(headers.length).fill(getRowStyle(data.type)), // ✅ you want style based on `data.type`
            );
         });

         // Create worksheet and workbook
         const ws = XLSX.utils.aoa_to_sheet(finalData);

         // Set column widths
         ws['!cols'] = [{ width: 40 }, { width: 20 }, { width: 1 }, { width: 40 }, { width: 20 }];

         // Apply styles to each cell
         styles.forEach((rowStyles, rowNum) => {
            rowStyles.forEach((style, colNum) => {
               if (style) {
                  const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                  if (!ws[cellAddress]) ws[cellAddress] = {};
                  ws[cellAddress].s = style;
               }
            });
         });

         const wb = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'BalanceSheet');
         XLSX.writeFile(wb, 'BalanceSheet.xlsx');
      }
   }, [balanceSheet]);

   const downloadPDF = useCallback(() => {
      const doc = new jsPDF({
         orientation: 'landscape',
         unit: 'mm',
         format: 'a4',
      });

      // Define colors to match your UI
      const colors = {
         companyHeader: [247, 236, 222], // #F7ECDE - Light orange for company headers
         categoryHeader: [241, 240, 232], // #F1F0E8 - Light beige for category headers (companyBg)
         tableHeader: [229, 231, 235], // #E5E7EB - Light gray for table headers
         evenRow: [245, 245, 245], // #F5F5F5 - Light gray for even rows
         oddRow: [255, 255, 255], // #FFFFFF - White for odd rows
         totalRow: [220, 252, 231], // #DCFCE7 - Light green for totals
         sectionHeader: [219, 234, 254], // #DBEAFE - Light blue for section headers
         text: [0, 0, 0], // Black text
         border: [156, 163, 175], // Gray border
      };

      // Set title
      doc.setFontSize(18);
      doc.setFont(undefined, 'bold');
      doc.text('Balance Sheet Report', doc.internal.pageSize.width / 2, 18, { align: 'center' });

      // Set date range
      doc.setFontSize(12);
      doc.setFont(undefined, 'normal');
      doc.text(`Date Range: ${dateRange.fromDate} to ${dateRange.toDate}`, doc.internal.pageSize.width / 2, 25, {
         align: 'center',
      });

      let yPosition = 30;
      const formatCurrency = (value) => {
         if (value === null || value === undefined) return '-';
         const numValue = Number(value);
         if (isNaN(numValue)) return value;
         return `${Math.abs(numValue).toLocaleString('en-IN')}`;
      };

      // Define column positions for better alignment
      const columnPositions = {
         liability: {
            name: 15,
            amount: 135, // Right edge of the amount column
         },
         asset: {
            name: doc.internal.pageSize.width / 2 + 10,
            amount: doc.internal.pageSize.width / 2 + 130, // Right edge of the amount column
         },
      };

      if (reportType === 'Balance sheet T Format') {
         // T-Format specific implementation
         balanceSheet.forEach((companyData, companyIndex) => {
            const companyName = companyData.companyName || '';
            const data = companyData.data || [];

            if (data.length === 0) return;

            // Add company header with background color
            doc.setFillColor(...colors.companyHeader);
            doc.rect(10, yPosition, doc.internal.pageSize.width - 20, 8, 'F');
            doc.setFontSize(8);
            doc.setFont(undefined, 'bold');
            doc.setTextColor(...colors.text);
            doc.text(companyName, 15, yPosition + 5);
            yPosition += 8;

            // Add table headers
            doc.setFillColor(...colors.tableHeader);
            doc.rect(10, yPosition, (doc.internal.pageSize.width - 20) / 2 - 5, 8, 'F');
            doc.rect(
               doc.internal.pageSize.width / 2 + 5,
               yPosition,
               (doc.internal.pageSize.width - 20) / 2 - 5,
               8,
               'F',
            );

            doc.setFontSize(8);
            doc.setFont(undefined, 'bold');
            doc.text('LIABILITY', 15, yPosition + 5);
            doc.text('AMOUNT', columnPositions.liability.amount, yPosition + 5, { align: 'right' });
            doc.text('ASSETS', columnPositions.asset.name, yPosition + 5);
            doc.text('AMOUNT', columnPositions.asset.amount, yPosition + 5, { align: 'right' });
            yPosition += 8;

            // Process data similar to your renderTFormatBalanceSheet
            const flattenedData = data.map((group) => ({
               ...group,
               data: group.data.map((item) => ({
                  ...item,
                  groupName: group.groupName,
                  debit: item.adjustedBalance < 0 ? Math.abs(item.adjustedBalance) : 0,
                  credit: item.adjustedBalance > 0 ? item.adjustedBalance : 0,
               })),
            }));

            const groupedData = flattenedData.reduce((acc, group) => {
               group.data.forEach((item) => {
                  const mainCategory =
                     item.debit && !item.credit ? 'Assets' : item.credit && !item.debit ? 'Liabilities' : 'Other';
                  const subCategory = group.groupName || 'Others';

                  if (!acc[mainCategory]) acc[mainCategory] = {};
                  if (!acc[mainCategory][subCategory]) acc[mainCategory][subCategory] = [];
                  acc[mainCategory][subCategory].push(item);
               });
               return acc;
            }, {});

            const liabilitiesData = groupedData['Liabilities'] || {};
            const assetsData = groupedData['Assets'] || {};
            const liabilityCategories = Object.keys(liabilitiesData);
            const assetCategories = Object.keys(assetsData);
            const maxCategories = Math.max(liabilityCategories.length, assetCategories.length);

            let rowIndex = 0;
            let totalLiabilities = 0;
            let totalAssets = 0;

            for (let i = 0; i < maxCategories; i++) {
               const liabilityCategory = liabilityCategories[i];
               const assetCategory = assetCategories[i];

               // Add category headers with background
               if (liabilityCategory || assetCategory) {
                  const isEven = rowIndex % 2 === 0;
                  doc.setFillColor(...colors.categoryHeader);
                  doc.rect(10, yPosition, doc.internal.pageSize.width - 20, 6, 'F');

                  doc.setFontSize(8);
                  doc.setFont(undefined, 'bold');
                  doc.text(
                     liabilityCategory ? liabilityCategory.toUpperCase() : '',
                     columnPositions.liability.name,
                     yPosition + 4,
                  );
                  doc.text(assetCategory ? assetCategory.toUpperCase() : '', columnPositions.asset.name, yPosition + 4);
                  yPosition += 6;
                  rowIndex++;
               }

               const liabilityItems = liabilityCategory ? liabilitiesData[liabilityCategory] : [];
               const assetItems = assetCategory ? assetsData[assetCategory] : [];
               const maxItems = Math.max(liabilityItems.length, assetItems.length);

               for (let j = 0; j < maxItems; j++) {
                  const liabilityItem = liabilityItems[j];
                  const assetItem = assetItems[j];

                  // Add row background
                  const isEven = rowIndex % 2 === 0;
                  doc.setFillColor(...(isEven ? colors.evenRow : colors.oddRow));
                  doc.rect(10, yPosition, doc.internal.pageSize.width - 20, 6, 'F');

                  // Add row data
                  doc.setFontSize(8);
                  doc.setFont(undefined, 'normal');

                  if (liabilityItem) {
                     doc.text(liabilityItem.accountName || '', columnPositions.liability.name, yPosition + 4);
                     const amount = formatCurrency(liabilityItem.credit);
                     doc.text(amount, columnPositions.liability.amount, yPosition + 4, { align: 'right' });
                     totalLiabilities += Number(liabilityItem.credit) || 0;
                  }

                  if (assetItem) {
                     doc.text(assetItem.accountName || '', columnPositions.asset.name, yPosition + 4);
                     const amount = formatCurrency(assetItem.debit);
                     doc.text(amount, columnPositions.asset.amount, yPosition + 4, { align: 'right' });
                     totalAssets += Number(assetItem.debit) || 0;
                  }

                  yPosition += 6;
                  rowIndex++;

                  // Check if we need a new page
                  if (yPosition > doc.internal.pageSize.height - 30) {
                     doc.addPage();
                     yPosition = 20;
                  }
               }
            }

            // Add totals with green background
            doc.setFillColor(...colors.totalRow);
            doc.rect(10, yPosition, doc.internal.pageSize.width - 20, 8, 'F');

            doc.setFontSize(8);
            doc.setFont(undefined, 'bold');
            doc.text('Grand Total:', columnPositions.liability.name, yPosition + 5);
            doc.text(formatCurrency(totalLiabilities), columnPositions.liability.amount, yPosition + 5, {
               align: 'right',
            });
            doc.text('Grand Total:', columnPositions.asset.name, yPosition + 5);
            doc.text(formatCurrency(totalAssets), columnPositions.asset.amount, yPosition + 5, { align: 'right' });
         });
      } else if (reportType === 'Balance sheet Summary') {
         // Summary format implementation
         balanceSheetSummary.forEach((companyData) => {
            const companyName = companyData.companyName || '';
            const balanceSheetData = companyData.data || [];

            // Add company header
            doc.setFillColor(...colors.companyHeader);
            doc.rect(10, yPosition, doc.internal.pageSize.width - 20, 8, 'F');
            doc.setFontSize(8);
            doc.setFont(undefined, 'bold');
            doc.text(companyName, 15, yPosition + 5);
            yPosition += 8;

            // Add headers
            doc.setFillColor(...colors.tableHeader);
            doc.rect(10, yPosition, doc.internal.pageSize.width - 20, 6, 'F');
            doc.setFontSize(8);
            doc.setFont(undefined, 'bold');
            doc.text('LIABILITY', columnPositions.liability.name, yPosition + 4);
            doc.text('AMOUNT', columnPositions.liability.amount, yPosition + 4, { align: 'right' });
            doc.text('ASSETS', columnPositions.asset.name, yPosition + 4);
            doc.text('AMOUNT', columnPositions.asset.amount, yPosition + 4, { align: 'right' });
            yPosition += 8;

            // Categorize data
            const liabilities = balanceSheetData.filter((item) => item.section === 'LIABILITIES');
            const assets = balanceSheetData.filter((item) => item.section === 'ASSETS');
            const maxRows = Math.max(liabilities.length, assets.length);

            for (let i = 0; i < maxRows; i++) {
               const isEven = i % 2 === 0;
               doc.setFillColor(...(isEven ? colors.evenRow : colors.oddRow));
               doc.rect(10, yPosition, doc.internal.pageSize.width - 20, 6, 'F');

               doc.setFontSize(8);
               doc.setFont(undefined, 'normal');

               if (liabilities[i]) {
                  doc.text(liabilities[i].category || '', columnPositions.liability.name, yPosition + 4);
                  doc.text(formatCurrency(liabilities[i].amount), columnPositions.liability.amount, yPosition + 4, {
                     align: 'right',
                  });
               }

               if (assets[i]) {
                  doc.text(assets[i].category || '', columnPositions.asset.name, yPosition + 4);
                  doc.text(formatCurrency(assets[i].amount), columnPositions.asset.amount, yPosition + 4, {
                     align: 'right',
                  });
               }

               yPosition += 6;
            }

            // Add totals
            const totalLiabilities = liabilities.reduce((sum, item) => sum + Number(item.amount || 0), 0);
            const totalAssets = assets.reduce((sum, item) => sum + Number(item.amount || 0), 0);

            doc.setFillColor(...colors.totalRow);
            doc.rect(10, yPosition, doc.internal.pageSize.width - 20, 8, 'F');
            doc.setFontSize(8);
            doc.setFont(undefined, 'bold');
            doc.text('Total Liabilities', columnPositions.liability.name, yPosition + 5);
            doc.text(formatCurrency(totalLiabilities), columnPositions.liability.amount, yPosition + 5, {
               align: 'right',
            });
            doc.text('Total Assets', columnPositions.asset.name, yPosition + 5);
            doc.text(formatCurrency(totalAssets), columnPositions.asset.amount, yPosition + 5, { align: 'right' });
         });
      } else if (reportType === 'Balance sheet Vertical') {
         // Vertical format implementation
         const verticalColumns = {
            account: 15,
            debit: 180,
            credit: 240,
         };

         // Add table headers for vertical format
         doc.setFillColor(...colors.tableHeader);
         doc.rect(10, yPosition, doc.internal.pageSize.width - 20, 8, 'F');
         doc.setFontSize(8);
         doc.setFont(undefined, 'bold');
         doc.text('ACCOUNT', verticalColumns.account, yPosition + 5);
         doc.text('DEBIT', verticalColumns.debit, yPosition + 5, { align: 'right' });
         doc.text('CREDIT', verticalColumns.credit, yPosition + 5, { align: 'right' });
         yPosition += 8;

         balanceSheetVertical.forEach((company, companyIndex) => {
            company.data.forEach((group, groupIndex) => {
               // Group header with background
               doc.setFillColor(...colors.sectionHeader);
               doc.rect(10, yPosition, doc.internal.pageSize.width - 20, 6, 'F');
               doc.setFontSize(8);
               doc.setFont(undefined, 'bold');
               doc.text(group.groupName, verticalColumns.account, yPosition + 4);
               yPosition += 6;

               // Items
               group.data.forEach((item, itemIndex) => {
                  const isEven = itemIndex % 2 === 0;
                  doc.setFillColor(...(isEven ? colors.evenRow : colors.oddRow));
                  doc.rect(10, yPosition, doc.internal.pageSize.width - 20, 5, 'F');

                  doc.setFontSize(8);
                  doc.setFont(undefined, 'normal');
                  doc.text(item.accountName || '', verticalColumns.account + 5, yPosition + 3.5); // Slightly indented for account names
                  doc.text(item.debit ? formatCurrency(item.debit) : '0.00', verticalColumns.debit, yPosition + 3.5, {
                     align: 'right',
                  });
                  doc.text(
                     item.credit ? formatCurrency(item.credit) : '0.00',
                     verticalColumns.credit,
                     yPosition + 3.5,
                     { align: 'right' },
                  );

                  yPosition += 6;

                  if (yPosition > doc.internal.pageSize.height - 30) {
                     doc.addPage();
                     yPosition = 20;
                  }
               });
            });
         });
      }

      // Save the PDF
      doc.save(`BalanceSheet_${reportType.replace(/\s+/g, '_')}_${dateRange.fromDate}_to_${dateRange.toDate}.pdf`);
   }, [balanceSheet, balanceSheetSummary, balanceSheetVertical, reportType, dateRange]);

   // Column visibility modal
   const ColumnVisibilityModal = useCallback(
      () => (
         <Modal isOpen={isColumnSelectorOpen} onClose={() => setIsColumnSelectorOpen(false)} size="md">
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Show/Hide Columns</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  {columns.map((column) => (
                     <Flex key={column.id} mb={2} alignItems="center">
                        <Checkbox
                           isChecked={columnVisibility[column.id]}
                           onChange={(e) => {
                              setColumnVisibility((prev) => ({
                                 ...prev,
                                 [column.id]: e.target.checked,
                              }));
                           }}
                           mr={2}
                        />
                        <Text>{column.headerText}</Text>
                     </Flex>
                  ))}
               </ModalBody>
               <ModalFooter>
                  <Button colorScheme="blue" onClick={() => setIsColumnSelectorOpen(false)}>
                     Close
                  </Button>
               </ModalFooter>
            </ModalContent>
         </Modal>
      ),
      [columns, columnVisibility, isColumnSelectorOpen],
   );

   return (
      <>
         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()}
                  style={{ cursor: 'pointer' }}
               />
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Balance Sheet
               </Text>
            </Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex alignItems="center" gap={3} justifyContent={'end'}>
               <div flex="1" mr={''} justifyContent="center">
                  <Box my={2} width="300px" fontSize={'13px'} fontWeight={500} display={{ base: 'none', xl: 'block' }}>
                     <GridItem className="seperator-width" mt={5}>
                        {renderDynamicDropdown(
                           'company',
                           'Company',
                           lastcompanyOptions,
                           {
                              value: companyFilter,
                              onChange: handleCompanyChange,
                           },
                           {},
                           textColor,
                           false,
                           'Select company',
                           true,
                           undefined,
                           true,
                        )}
                     </GridItem>
                  </Box>
               </div>
               <Box flex="1" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last7Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>

                  <Box my={2} zIndex={3} fontSize={'13px'} fontWeight={500}>
                     <label>Report Type</label>
                     <Select
                        options={reportTypeOptions}
                        value={reportTypeOptions.find((option) => option.value === reportType)}
                        onChange={(selectedOption) => {
                           setReportType(selectedOption.value);
                           setExpandedItems({});
                        }}
                        placeholder="Select Report Type"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           menu: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
               </Box>
               <Flex>
                  <Box flex="1" mr={3}>
                     <MotionFlex
                        ref={wrapperRef}
                        align="center"
                        bg={bg}
                        borderRadius="full"
                        cursor="pointer"
                        px={expanded ? 3 : 0}
                        w={expanded ? '250px' : '40px'}
                        h="40px"
                        transition="all 0.3s ease"
                        onClick={() => setExpanded(true)}>
                        <MotionSearchIcon
                           color={icon}
                           animate={{ rotate: expanded ? 0 : 90 }}
                           transition={{ duration: 0.3 }}
                           style={{
                              marginRight: expanded ? '8px' : '10px',
                              marginLeft: expanded ? '0' : '10px',
                           }}
                        />
                        {expanded && (
                           <Input
                              variant="unstyled"
                              placeholder="Search accounts..."
                              value={searchQuery}
                              onChange={handleSearchChange}
                              color={icon}
                              flex="1"
                           />
                        )}
                     </MotionFlex>
                  </Box>
                  <Button onClick={handleRefresh} _hover={{ bg: 'blue.50' }} mr={2}>
                     <LuRefreshCcw size={20} mr={2} />
                  </Button>
                  <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                     <IoFilterOutline size={22} />
                  </Button>
                  <Flex alignItems="center">
                     <Popover>
                        <PopoverTrigger>
                           <IconButton icon={<Image src={Download} boxSize="24px" />} aria-label="Download Options" />
                        </PopoverTrigger>
                        <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                           <PopoverBody p="3">
                              <Button
                                 width="100%"
                                 variant="ghost"
                                 _hover={{ bg: 'blue.100' }}
                                 onClick={downloadExcel}
                                 justifyContent="space-between"
                                 mb={3}>
                                 <img src={xls} alt="Download XLS" width="30px" />
                                 Download Excel
                              </Button>
                              <Button
                                 width="100%"
                                 variant="ghost"
                                 _hover={{ bg: 'blue.100' }}
                                 onClick={downloadPDF}
                                 justifyContent="space-between">
                                 <img src={xls} alt="Download PDF" width="30px" />
                                 Download PDF
                              </Button>
                           </PopoverBody>
                        </PopoverContent>
                     </Popover>
                  </Flex>
               </Flex>
               <Box ml={''}>
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={fromDateInputRef}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                        <Box my={2} fontSize={'13px'} fontWeight={500}>
                           <label>Report Type</label>
                           <Select
                              options={reportTypeOptions}
                              value={reportTypeOptions.find((option) => option.value === reportType)}
                              onChange={(selectedOption) => {
                                 setReportType(selectedOption.value);
                                 setExpandedItems({});
                              }}
                              placeholder="Select Report Type"
                           />
                        </Box>
                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker
                              value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                              onChange={handleDateRangeChange}
                              defaultPeriod="last7Days"
                              style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>
                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '60vh', md: '65vh', xl: '70vh' }}
                  maxH={{ base: '60vh', md: '65vh', xl: '70vh' }}>
                  {reportType === 'Balance sheet T Format' || reportType === 'Balance sheet Summary' ? (
                     <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                        <Thead>
                           <Tr
                              bg={'#F5F5F5'}
                              position="sticky"
                              top="-1"
                              zIndex="1"
                              color={textColor}
                              borderTop="1px solid"
                              borderBottom="1px solid"
                              borderColor={borderColor}>
                              <Th
                                 cursor="pointer"
                                 p="2px"
                                 py="4px"
                                 _dark={{ bg: '#080238' }}
                                 fontWeight="600"
                                 whiteSpace="nowrap">
                                 <Text fontSize={{ sm: '10px', lg: '12px' }} color={textColor}>
                                    Liability
                                 </Text>
                              </Th>
                              <Th
                                 cursor="pointer"
                                 p="2px"
                                 py="4px"
                                 _dark={{ bg: '#080238' }}
                                 fontWeight="600"
                                 whiteSpace="nowrap"
                                 isNumeric>
                                 <Text fontSize={{ sm: '10px', lg: '12px' }} color={textColor}>
                                    Amount
                                 </Text>
                              </Th>
                              <Th width="10%" _dark={{ bg: '#080238' }}></Th>
                              <Th
                                 cursor="pointer"
                                 p="2px"
                                 py="4px"
                                 _dark={{ bg: '#080238' }}
                                 fontWeight="600"
                                 position="sticky"
                                 top="-1"
                                 zIndex="1"
                                 whiteSpace="nowrap">
                                 <Text fontSize={{ sm: '10px', lg: '12px' }} color={textColor}>
                                    Assets
                                 </Text>
                              </Th>
                              <Th
                                 cursor="pointer"
                                 p="2px"
                                 py="4px"
                                 _dark={{ bg: '#080238' }}
                                 fontWeight="600"
                                 whiteSpace="nowrap"
                                 isNumeric>
                                 <Text fontSize={{ sm: '10px', lg: '12px' }} color={textColor}>
                                    Amount
                                 </Text>
                              </Th>
                           </Tr>
                        </Thead>
                        <Tbody>{renderReportContent()}</Tbody>
                     </Table>
                  ) : (
                     <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                        <Thead>
                           {table.getHeaderGroups().map((headerGroup) => (
                              <Tr key={headerGroup.id}>
                                 {headerGroup.headers.map((header) => {
                                    if (!header.column.getIsVisible()) return null;

                                    const columnId = header.column.id;
                                    const isNumericColumn = ['debit', 'credit'].includes(columnId);

                                    return (
                                       <Th
                                          borderTop="1px solid"
                                          key={header.id}
                                          colSpan={header.colSpan}
                                          borderColor={borderColor}
                                          cursor="pointer"
                                          p="2px"
                                          py="4px"
                                          fontSize="10px"
                                          _dark={{ bg: '#080238' }}
                                          fontWeight="600"
                                          bg={'#F5F5F5'}
                                          position="sticky"
                                          top="-1"
                                          zIndex="1"
                                          color={textColor}
                                          isNumeric={isNumericColumn}
                                          whiteSpace="nowrap"
                                          onClick={header.column.getToggleSortingHandler()}>
                                          <Flex
                                             justifyContent={isNumericColumn ? 'flex-end' : 'space-between'}
                                             align="center"
                                             fontSize={{ sm: '10px', lg: '12px' }}
                                             color={textColor}>
                                             {flexRender(header.column.columnDef.header, header.getContext())}
                                             {{
                                                asc: '↑',
                                                desc: '↓',
                                             }[header.column.getIsSorted()] ?? null}
                                          </Flex>
                                       </Th>
                                    );
                                 })}
                              </Tr>
                           ))}
                        </Thead>
                        <Tbody>{renderReportContent()}</Tbody>
                     </Table>
                  )}
               </Box>
            </Card>
         </Grid>

         <ColumnVisibilityModal />

         <StatementFilter
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyIds}
            fromDate={dateRange.fromDate}
            toDate={dateRange.toDate}
            accountId={companyIds}
            entityType="Balance Sheet"
         />
      </>
   );
};

export default BalanceSheet;
